import { useEffect, useRef, useState, useCallback } from 'react'
import { fetchTopCategories } from '../lib/categories'
import { useNavigate, useSearchParams } from 'react-router-dom'
function slugify(s = '') {
    return s.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
}
function formatCatLabel(label = '') {
    return String(label)
        .toLowerCase()
        .split(' ')
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ')
}

export default function CategoriesBar() {
    const [cats, setCats] = useState([])
    const [loading, setLoading] = useState(true)
    const [params] = useSearchParams()
    const navigate = useNavigate()
    const activeId = params.get('cat') || ''
    const scrollerRef = useRef(null)
    const [canPrev, setCanPrev] = useState(false)
    const [canNext, setCanNext] = useState(false)

    const updateScrollShadows = useCallback(() => {
        const el = scrollerRef.current
        if (!el) return
        const { scrollLeft, scrollWidth, clientWidth } = el
        setCanPrev(scrollLeft > 0)
        setCanNext(scrollLeft + clientWidth < scrollWidth - 1)
    }, [])

    const handleScroll = useCallback(() => {
        updateScrollShadows()
    }, [updateScrollShadows])

    const loadCats = useCallback(async () => {
        const rows = await fetchTopCategories()
        setCats(rows)
        setLoading(false)
        requestAnimationFrame(updateScrollShadows)
    }, [updateScrollShadows])

    useEffect(() => {
        loadCats()
    }, [loadCats])

    const scrollByAmount = useCallback((dir = 1) => {
        const el = scrollerRef.current
        if (!el) return
        const amount = Math.round(el.clientWidth * 0.8)
        el.scrollBy({ left: dir * amount, behavior: 'smooth' })
    }, [])

    if (loading) {
        return (
            <div className="cats-bar">
                <div className="container py-2 small text-muted">Chargement des catégories…</div>
            </div>
        )
    }
    if (!cats.length) return null

    return (
        <div className="cats-bar position-sticky top-0">
            <div className="container position-relative">
                <button
                    type="button"
                    className={`cats-nav cats-nav-left ${canPrev ? 'show' : ''}`}
                    aria-label="Précédent"
                    onClick={() => scrollByAmount(-1)}
                >
                    ‹
                </button>

                <div
                    ref={scrollerRef}
                    className="cats-scroller"
                    role="tablist"
                    aria-label="Catégories"
                    onScroll={handleScroll}
                >
                    {/* <button
                        role="tab"
                        className={`cat-pill ${activeId === '' ? 'active' : ''}`}
                        onClick={() => navigate('/catalog')}
                    >
                        Tous
                    </button> */}
                    {cats.map(c => (
                        <button
                            key={c.id}
                            role="tab"
                            className={`cat-pill ${activeId === String(c.id) ? 'active' : ''}`}
                            title={c.label}
                            onClick={() => navigate(`/c/${encodeURIComponent(c.id)}/${slugify(c.label)}`)}
                        >
                            <span className="cat-dot" aria-hidden="true" />
                            <span className="cat-text">{formatCatLabel(c.label)}</span>
                        </button>
                    ))}
                </div>

                <button
                    type="button"
                    className={`cats-nav cats-nav-right ${canNext ? 'show' : ''}`}
                    aria-label="Suivant"
                    onClick={() => scrollByAmount(1)}
                >
                    ›
                </button>

                <div className={`cats-fade left ${canPrev ? 'show' : ''}`} />
                <div className={`cats-fade right ${canNext ? 'show' : ''}`} />
            </div>
        </div>
    )
}
